import 'mediaelement/build/mediaelement-and-player.min';

export default function (el, htmlOptions) {
    $('audio').mediaelementplayer();
};
